// Help section — QQ group + player wiki, the two links the legacy page
// hides behind the 更多 panel; zero-click reachable here.
export function Help() {
  return (
    <section className="wv-h2-section wv-h2-section--white" id="help">
      <div className="wv-h2-wrap">
        <h2>遇到问题？</h2>
        <div className="wv-h2-section-rule"></div>
        <p className="wv-h2-lead">你可以查看玩家WIKI，或加入QQ群与大家一起欢乐交流。</p>
        <div className="wv-h2-help-cards">
          <a
            className="wv-h2-card"
            href="http://shang.qq.com/wpa/qunwpa?idkey=3b2e0e7ac00293e6605c06c9e222625b7c79b916e599e18d4a61b4cb487566e4"
            target="_blank"
            rel="noreferrer"
          >
            <div className="wv-h2-card-icon">✈</div>
            <h3>QQ群392455229</h3>
          </a>
          <a className="wv-h2-card" href="https://wiki.evermc.com" target="_blank" rel="noreferrer">
            <div className="wv-h2-card-icon">?</div>
            <h3>玩家WIKI</h3>
          </a>
        </div>
      </div>
    </section>
  );
}
